import { connect } from "react-redux";

import Header from "../../components/pages/newLandingPage/header";

const mapStateToProps = (state) => {
  return {
    loginRedirectionURL: state.config.seaChange.login,
    registrationRedirectionURL: state.config.seaChange.registration,
    splashScreenVisibilityStatus: state.splashScreen.splashScreenVisibilityStatus
  }
};


export default connect(mapStateToProps, null)(Header);



// WEBPACK FOOTER //
// ./src/js/containers/widgets/header.js